"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = require("axios");
// Checks if value is already registered to an account
exports.uniqueCheck = function (username, IDMbaseurl) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, body;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = IDMbaseurl + '/openidm/endpoint/uniqueCheck';
          headers = {
            'X-OpenIDM-Password': 'anonymous',
            'X-OpenIDM-Username': 'anonymous',
            'Content-Type': 'application/json'
          };
          body = {
            'username': username
          };
          return [4 /*yield*/, axios_1.default({
            headers: headers,
            method: 'post',
            data: body,
            url: url
          }).then(function (response) {
            return handleUniqueCheckResponse(response);
          }).catch(function (err) {
            return handleIDMError(err);
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
// Creates a local password for a socially registered user
exports.createPassword = function (code, username, password, IDMbaseurl) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, headers, body;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = IDMbaseurl + '/openidm/endpoint/makePassword';
          headers = {
            'X-OpenIDM-Password': 'anonymous',
            'X-OpenIDM-Username': 'anonymous',
            'Content-Type': 'application/json'
          };
          body = {
            'code': code,
            'username': username,
            'password': password
          };
          return [4 /*yield*/, axios_1.default({
            headers: headers,
            method: 'post',
            data: body,
            url: url
          }).then(function (response) {
            return handleCreatePasswordResponse(response);
          }).catch(function (err) {
            return handleIDMError(err);
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var handleUniqueCheckResponse = function (resp) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      // Success case
      if (resp.data.code === 200) {
        return [2 /*return*/, {
          'code': 200,
          'resp': resp,
          'state': {
            'available': true
          }
        }];
      } else if (resp.data.code === 418) {
        // Invalid code case, let the UI know
        return [2 /*return*/, {
          'code': 418,
          'resp': resp,
          'state': {
            'available': false
          }
        }];
      } else {
        // Unexpected, non-erroneous response from IDM. This is invalid, so let the UI know.
        return [2 /*return*/, {
          'code': 500,
          'resp': resp,
          'state': {
            'available': false
          }
        }];
      }
      return [2 /*return*/];
    });
  });
};
var handleCreatePasswordResponse = function (resp) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      // Success case
      if (resp.data.code === 200) {
        return [2 /*return*/, {
          'code': 200,
          'resp': resp
        }];
      } else if (resp.data.code === 401) {
        // Invalid code case, let the UI know
        return [2 /*return*/, {
          'code': 401,
          'resp': resp
        }];
      } else if (resp.data.code === 403) {
        return [2 /*return*/, {
          'code': 403,
          'resp': resp
        }];
      } else {
        // Unexpected, non-erroneous response from IDM. This is invalid, so let the UI know.
        return [2 /*return*/, {
          'code': 400,
          'resp': resp
        }];
      }
      return [2 /*return*/];
    });
  });
};
var handleIDMError = function (error) {
  // set state loading false and responseValid false
  return {
    'code': 400,
    'resp': error
  };
};